import localforage from 'localforage';
import type { Action, Reducer } from 'redux';
import type { PersistMigrate } from 'redux-persist';
import { persistReducer as persist, purgeStoredState } from 'redux-persist';

const config = {
  storage: localforage,
  keyPrefix: 'slab',
};
const keys: string[] = [];

export function purgePersisted() {
  keys.forEach((key) => {
    purgeStoredState({
      ...config,
      key,
    });
  });
}

export function persistReducer<S, A extends Action = Action>(
  options: { key: string; whitelist: string[]; migrate?: PersistMigrate },
  reducer: Reducer<S, A>,
) {
  keys.push(options.key);
  return persist({ ...config, ...options }, reducer);
}
